var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { stringBuilder } from '../util';
import SVG from 'react-inlinesvg';
import { IconVariant, isComponent, isInlineSvg, isSymbolObject, isSymbolString } from './types';
const TuxIcon = (props) => {
    const { ariaHidden, className, color, screenReaderLabel, svg, size, variant = IconVariant.Default } = props, rest = __rest(props, ["ariaHidden", "className", "color", "screenReaderLabel", "svg", "size", "variant"]);
    const classes = stringBuilder('icon', size, variant, className);
    const Icon = svg;
    const commonProps = {
        'aria-hidden': ariaHidden,
        className: classes,
        style: { color }
    };
    return (_jsxs(_Fragment, { children: [(isSymbolObject(svg) || isSymbolString(svg)) && (_jsx("svg", Object.assign({}, rest, commonProps, { children: _jsx("use", { href: isSymbolObject(svg) ? `#${svg.id}` : svg }, void 0) }), void 0)), isInlineSvg(svg) && (_jsx(SVG, Object.assign({}, rest, commonProps, { onError: (e) => {
                    throw new Error(`Something went wrong fetching the SVG icon ${svg}:\n\n ${e}`);
                }, src: svg }), void 0)), isComponent(Icon) && _jsx(Icon, Object.assign({}, rest, commonProps), void 0), !!screenReaderLabel && (_jsx("span", Object.assign({ className: "sr-only" }, { children: screenReaderLabel }), void 0))] }, void 0));
};
export default TuxIcon;
